import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../../components/useTable";
//UI
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { Input, Radio } from '../../../../ui/inputs/Input';

const headCells = [
  {
    id: "desde",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Desde",
    textAlign: "center",
  },
  {
    id: "hasta",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Hasta",
    textAlign: "center",
  },
  {
    id: "valor",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Valor",
    textAlign: "center",
  },
];

export default function Tablas({ show, setShow, setTabla }) {
  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    tableData,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Tablas</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <ul className="nav d-flex flex-wrap gap-1 align-items-center mb-2" id="ex-with-icons" role="tablist">

          <li class="nav-item" role="presentation">
            <button
              className="nav-link active bg-blue-100 text-light rounded h-100"

              id="datos-tab"
              data-bs-toggle="tab"
              data-bs-target="#datos-tab-pane"
              type="button"
              role="tab"
              aria-controls="datos-tab-pane"
              aria-selected="true"
            >
              Datos de la Tabla
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-200 text-light rounded"

              id="detalles-tab"
              data-bs-toggle="tab"
              data-bs-target="#detalles-tab-pane"
              type="button"
              role="tab"
              aria-controls="detalles-tab-pane"
              aria-selected="false"
            >
              Detalles
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="datos-tab-pane"
            role="tabpanel"
            aria-labelledby="datos-tab"
            tabindex="0"
          >
            <form
              onSubmit={(e) => e.preventDefault()}
              className="col-12 m-0 p-0 d-flex flex-wrap align-items-center"
            >
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Cod. Tabla:" />
              </div>
              <div className="col-9 m-0 mb-2 p-0 pl-2">
                <Input label="Nombre de la tabla:" />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Input label="Unidad:" />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
                <legend className="m-0 w-auto float-none">
                  Campo para el Calculo
                </legend>
                <div className="col-auto m-0 p-0">
                  <Radio label="Fecha de Ingreso" name="campo" id="campo1" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio
                    label="Fecha de Ingreso Para Vacaciones"
                    name="campo"
                    id="campo2"
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label="Cargo" name="campo" id="campo3" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio
                    label="Fecha de Ingreso Admin. Pública"
                    name="campo"
                    id="campo4"
                  />
                </div>
              </fieldset>
            </form>
          </div>
          <div
            class="tab-pane fade"
            id="detalles-tab-pane"
            role="tabpanel"
            aria-labelledby="detalles-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-11 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {tableData &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr key={index}></tr>
                      ))}
                  </tbody>
                </TblContainer>
              </div>
              <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
                <div className="col-auto m-0 p-0">
                  <PrimaryButton icon="fa-plus m-0" />
                </div>
                <div className="col-auto m-0 p-0">
                  <InfoButton icon="fa-eye m-0" />
                </div>
                <div className="col-auto m-0 p-0">
                  <WarningButton icon="fa-edit m-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
